import React from 'react';
import { Icon } from '../../icons';
import './Breadcrumbs.css';

export interface BreadcrumbItem {
  text: string;
  to?: string;
  active?: boolean;
  completed?: boolean;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  ariaLabel?: string;
}

export const Breadcrumbs = React.memo(function Breadcrumbs({ items, ariaLabel }: BreadcrumbsProps) {
  return (
    <nav className="breadcrumbs" aria-label={ariaLabel || 'Breadcrumbs'}>
      <ol>
        {items.map((item, index) => (
          <li key={index} className={item.active ? 'breadcrumbs__item--active' : ''}>
            {item.to ? (
              <a href={item.to} className="breadcrumbs__link">
                {item.text}
              </a>
            ) : (
              <span className="breadcrumbs__text">{item.text}</span>
            )}
            {item.completed && (
              <Icon name="CheckCircle" className="breadcrumbs__icon--check" aria-hidden="true" />
            )}
            {index < items.length - 1 && (
              <Icon name="ChevronRight" className="breadcrumbs__icon--arrow" aria-hidden="true" />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
});
